/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * goCancels
 * @export
 * @interface GoCancelRequest
 */
export interface GoCancelRequest {
    /**
     * 空車での trip_session_id
     * @type {string}
     * @memberof GoCancelRequest
     */
    unladenTripSessionId?: string;
    /**
     * ログイン(開局) 単位で発行されるID
     * @type {string}
     * @memberof GoCancelRequest
     */
    loginSessionId?: string;
    /**
     * 営業所ID
     * @type {number}
     * @memberof GoCancelRequest
     */
    officeId?: number;
}

export function GoCancelRequestFromJSON(json: any): GoCancelRequest {
    return GoCancelRequestFromJSONTyped(json, false);
}

export function GoCancelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoCancelRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'unladenTripSessionId': !exists(json, 'unladen_trip_session_id') ? undefined : json['unladen_trip_session_id'],
        'loginSessionId': !exists(json, 'login_session_id') ? undefined : json['login_session_id'],
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
    };
}

export function GoCancelRequestToJSON(value?: GoCancelRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'unladen_trip_session_id': value.unladenTripSessionId,
        'login_session_id': value.loginSessionId,
        'office_id': value.officeId,
    };
}


